module.exports = __webpack_public_path__ + "assets/img/laguna.9583ae9e.png";